import { CloseIcon } from "@chakra-ui/icons";
import { Box, Button, Flex, Image, Text } from "@chakra-ui/react";
import { useMainChatContext } from "@root/context/kps-chat-context";
import { useScrollToBottomButton } from "@root/hooks/useScrollToBottomButton";
import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import DefaultImage from "@assets/images/ChatSourceDefaultImage.svg";

const ChatSources = () => {
  const { sourcesData, setSourcesData } = useMainChatContext();
  const { t } = useTranslation("common");
  const arr = [1, 2, 3, 4, 5, 7, 8, 9];
  const divRef = useRef<HTMLDivElement>(null);
  const { showScrollButton, scrollToBottom } = useScrollToBottomButton(divRef);
  const navigate = useNavigate();

  const goToSource = (source: any) => {
    const filename = source?.filename || "";
    const fileExtension = filename.split(".").pop()?.toLowerCase();
    if (typeof source === "object") {
      window.open(source?.signedUrl, "_blank");
    } else {
      window.open(source, "_blank");
    }
  };

  console.log("sources Data zz: ", sourcesData);

  return (
    <Flex
      py={"15px"}
      px={"15px"}
      flexDir={"column"}
      height={"100%"}
      position={"relative"}
    >
      <Flex justifyContent={"space-between"} alignItems={"center"}>
        <Text fontSize={"20px"} fontWeight={600} color={"#111827"} ml={"8px"}>
          {t("translate.allSources")}
        </Text>
        <CloseIcon onClick={() => setSourcesData(null)} cursor={"pointer"} />
      </Flex>
      <Box
        flex={1}
        overflowY={"auto"}
        css={{
          "&::-webkit-scrollbar": {
            width: "4px",
          },
          "&::-webkit-scrollbar-track": {
            background: "transparent",
          },
          "&::-webkit-scrollbar-thumb": {
            background: "#e2e8f0",
            borderRadius: "2px",
          },
          "&::-webkit-scrollbar-thumb:hover": {
            background: "#cbd5e0",
          },
        }}
      >
        <Box mt={"30px"}>
          <Flex flexDir={"column"}>
            {sourcesData?.map((source: any, index: number) => (
              <Flex
                key={source?.filename}
                borderBottom={"2px solid #E2E8F0"}
                px={"15px"}
                py={"12px"}
                mx={"8px"}
                gap={"15px"}
                cursor={"pointer"}
                _hover={{
                  bgColor: "#E6E6E6",
                }}
                onClick={() => goToSource(source)}
              >
                <Box>
                  {source?.folder_name && (
                    <Text noOfLines={1} fontWeight={600} color={"#231F20"}>
                      {source?.folder_name}
                    </Text>
                  )}
                  <Text
                    mt={"4px"}
                    noOfLines={2}
                    fontSize={"14px"}
                    color={"#6D6D70"}
                  >
                    {source?.filename?.split("/").pop() ||
                      source?.filename ||
                      source}
                  </Text>
                </Box>
              </Flex>
            ))}
          </Flex>
        </Box>
      </Box>
    </Flex>
  );
};

export default ChatSources;
